import React from 'react';
import { Grid } from '@material-ui/core';
import Spouse from './Spouse';
import ApplicantAddInfo from './ApplicantAddInfo';

const Profile = ({
	handleEmployer,
	handleProfession,
	handleSalaryNet,
	handleHomeAddress,
	handleEmploymentType,
	handleWorkCertificate,
	handleDistrict,
	handleDistrict2,
	handleDistrictQuestion,
	handleGuardian,
	handleGuardianCertificate,
	handleHouseholdDisability,
	handleMaritalStatus,
	handleMaritalStatusCertificate,
	handleSpouseNationaId,
	handleSpousePhone,
	handleSpouseHomeAddress,
	handleSpouseEmployerName,
	handleSpouseProfession,
	handleSpouseSalary,
	handleSpouseEmploymentType,
	handleSpouseCertificate,
	employerName,
	profession,
	salarynet,
	homeAddress,
	employmentType,
	workCertificate,
	fileInputError,
	district,
	district2,
	districtQuestion,
	isGuardian,
	guardianCertificate,
	maritalStatus,
	maritalStatusCertificate,
	householdDisability,
	spouseNationalId,
	spousePhone,
	spouseHomeAddress,
	spouseEmployerName,
	spouseProfession,
	spouseSalarynet,
	spouseEmploymentType,
	spouseWorkCertificate,
	fieldError,
	provinces,
	handleProvince,
	province,
	districts,
	handleDistrictLocation,
	districtLocation,
	sectors,
	sector,
	handleSector,
	handleCell,
	cells,
	cell,
	handleVillage,
	villages,
	village,
	handleSpouseProvince,
	spouseProvince,
	handleSpouseDistrict,
	spouseDistrict,
	handleSpouseSector,
	spouseSector,
	handleSpouseCell,
	spouseCell,
	handleSpouseVillage,
	spouseVillage,
	salary,
	spouseSalary,
	requestSpouseNames,
	handleFirstName,
	handleLastName,
	spouseGender,
	handleGender,
	handDateOfBirth
}) => {
	return (
		<div>
			<Grid container direction='column' spacing={5}>
				<Grid item>
					<Grid container spacing={4} style={{ marginTop: 15 }}>
						<Grid item xs={12} sm={12} md={5}>
							<ApplicantAddInfo
								handleEmployer={handleEmployer}
								handleProfession={handleProfession}
								handleSalaryNet={handleSalaryNet}
								handleHomeAddress={handleHomeAddress}
								handleEmploymentType={handleEmploymentType}
								handleWorkCertificate={handleWorkCertificate}
								fileInputError={fileInputError}
								handleDistrict={handleDistrict}
								handleDistrict2={handleDistrict2}
								handleDistrictQuestion={handleDistrictQuestion}
								handleGuardian={handleGuardian}
								handleGuardianCertificate={handleGuardianCertificate}
								handleMaritalStatus={handleMaritalStatus}
								handleMaritalStatusCertificate={handleMaritalStatusCertificate}
								handleHouseholdDisability={handleHouseholdDisability}
								employerName={employerName}
								profession={profession}
								salarynet={salarynet}
								homeAddress={homeAddress}
								employmentType={employmentType}
								workCertificate={workCertificate}
								district={district}
								district2={district2}
								districtQuestion={districtQuestion}
								isGuardian={isGuardian}
								guardianCertificate={guardianCertificate}
								maritalStatus={maritalStatus}
								maritalStatusCertificate={maritalStatusCertificate}
								householdDisability={householdDisability}
								fieldError={fieldError}
								provinces={provinces}
								handleProvince={handleProvince}
								province={province}
								districts={districts}
								handleDistrictLocation={handleDistrictLocation}
								districtLocation={districtLocation}
								sectors={sectors}
								handleSector={handleSector}
								sector={sector}
								handleCell={handleCell}
								cell={cell}
								cells={cells}
								handleVillage={handleVillage}
								village={village}
								villages={villages}
								salary={salary}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={5}>
							{maritalStatus === 'Married' && (
								<Spouse
									handleSpouseNationaId={handleSpouseNationaId}
									handleSpousePhone={handleSpousePhone}
									handleSpouseHomeAddress={handleSpouseHomeAddress}
									handleSpouseEmployerName={handleSpouseEmployerName}
									handleSpouseProfession={handleSpouseProfession}
									handleSpouseSalary={handleSpouseSalary}
									handleSpouseEmploymentType={handleSpouseEmploymentType}
									handleSpouseCertificate={handleSpouseCertificate}
									handleMaritalStatusCertificate={
										handleMaritalStatusCertificate
									}
									spouseNationalId={spouseNationalId}
									spousePhone={spousePhone}
									spouseHomeAddress={spouseHomeAddress}
									spouseEmployerName={spouseEmployerName}
									spouseProfession={spouseProfession}
									spouseSalarynet={spouseSalarynet}
									spouseEmploymentType={spouseEmploymentType}
									spouseWorkCertificate={spouseWorkCertificate}
									maritalStatusCertificate={maritalStatusCertificate}
									fieldError={fieldError}
									provinces={provinces}
									handleProvince={handleProvince}
									province={province}
									districts={districts}
									handleDistrictLocation={handleDistrictLocation}
									districtLocation={districtLocation}
									sectors={sectors}
									handleSector={handleSector}
									sector={sector}
									handleCell={handleCell}
									cell={cell}
									cells={cells}
									handleVillage={handleVillage}
									village={village}
									villages={villages}
									handleSpouseProvince={handleSpouseProvince}
									spouseProvince={spouseProvince}
									handleSpouseDistrict={handleSpouseDistrict}
									spouseDistrict={spouseDistrict}
									handleSpouseSector={handleSpouseSector}
									spouseSector={spouseSector}
									handleSpouseCell={handleSpouseCell}
									spouseCell={spouseCell}
									handleSpouseVillage={handleSpouseVillage}
									spouseVillage={spouseVillage}
									spouseSalary={spouseSalary}
									requestSpouseNames={requestSpouseNames}
									handleFirstName={handleFirstName}
									handleLastName={handleLastName}
									spouseGender={spouseGender}
									handleGender={handleGender}
									handDateOfBirth={handDateOfBirth}
								/>
							)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
};

export default Profile;
